export const getObjectId = <T extends { _id: string }>(value: string | T) => {
  if (typeof value === "object") {
    return value._id;
  } else {
    return value;
  }
};
